import api, { MainDomain } from 'api';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { actions } from 'redux/reducers';
import { RootState } from 'types';
import './background.scss';

function Background({
    open,
    setOpen
}: {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>
}) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const board = useSelector((state: RootState) => state.board);
    const [background, setBackground] = useState<string | null>('');

    const selectBackground = (fileName: string) => {
        dispatch(actions.board.set({
            ...board,
            Background: fileName
        }));
        api.board.update(params.boardId, board.Board.Description, fileName);
    }

    const uploadBackground = (file: File) => {
        api.board.background(params.boardId, file).then(() => {
            api.board.get(params.boardId).then(data => {
                dispatch(actions.board.set(data));
            })
        })
    }

    useEffect(() => {
        setBackground(board?.Board?.Background ? `https://workflow-api.${MainDomain}.co.za/api/board/${params.boardId}/background/${board.Board.Background}` : null);
        // setBackground(board?.Background ? `https://workflow-api.amasocial.co.za/api/board/${params.boardId}/background/${board.Background}` : null);
    }, [board, params.boardId])

    return (
        <div id="background" className={`${open ? 'open' : ''}`} onClick={e => e.stopPropagation()}>
            <div className="background-header">
                <i className="fal fa-times" onClick={() => {
                    setOpen(false);
                }}></i>
                <p>Background</p>
                <span><i className="far fa-trash"></i>Remove</span>
            </div>
            <div className="background-body">
                {background ? (
                    <img id="current" src={background} alt="Background" />
                ) : (
                    <div id="no-image">
                        <span><i className="fal fa-sad-tear"></i>No background</span>
                    </div>
                )}
                <div className="background-presets">
                    <div style={{ background: `url(${process.env.PUBLIC_URL}/img/defaultbg.png) no-repeat center` }} onClick={() => selectBackground(`defaultbg.png`)}></div>
                    <div style={{ background: `url(${process.env.PUBLIC_URL}/img/background-1.jpg) no-repeat center` }} onClick={() => selectBackground(`background-1.jpg`)}></div>
                    <div style={{ background: `url(${process.env.PUBLIC_URL}/img/background-2.jpg) no-repeat center` }} onClick={() => selectBackground(`background-2.jpg`)}></div>
                    <div style={{ background: `url(${process.env.PUBLIC_URL}/img/background-3.jpg) no-repeat center` }} onClick={() => selectBackground(`background-3.jpg`)}></div>
                    <div style={{ background: `url(${process.env.PUBLIC_URL}/img/background-4.jpg) no-repeat center` }} onClick={() => selectBackground(`background-4.jpg`)}></div>
                    <div style={{ background: `url(${process.env.PUBLIC_URL}/img/background-5.jpg) no-repeat center` }} onClick={() => selectBackground(`background-5.jpg`)}></div>
                    <div>
                        <input type="file" accept="image/*" className="upload" onChange={(e) => {
                            uploadBackground(e.currentTarget.files![0]);
                            e.currentTarget.value = "";
                            e.currentTarget.files = null;
                        }} />
                        <span><i className="fal fa-upload"></i> Choose</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Background;